import { ApplicationConfig, provideExperimentalZonelessChangeDetection, isDevMode } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration, withEventReplay, withIncrementalHydration } from '@angular/platform-browser';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideLuxonDateAdapter } from '@angular/material-luxon-adapter';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { registerLocaleData } from '@angular/common';

import localePl from '@angular/common/locales/pl';

import { provideConfigApiBaseUrl, provideWebAppApiBaseUrl } from '@rent2end/core/api-clients';
import { provideFirebaseAuth } from '@rent2end/core/auth';
import { provideFirebaseOptions } from '@rent2end/core/firebase';
import { provideGlobalErrorHandler } from '@rent2end/core/error';
import { provideLocaleId, provideStaticTranslation, provideTranslationAppInitializer } from '@rent2end/core/translation';
import { provideSnackbar } from '@rent2end/core/snackbar';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

registerLocaleData(localePl);

export const appConfig: ApplicationConfig = {
  providers: [
    // Angular providers
    provideAnimationsAsync(),
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideExperimentalZonelessChangeDetection(),
    provideHttpClient(withFetch()),
    provideLuxonDateAdapter(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideServiceWorker(`r2esw-worker.js?${new URLSearchParams({
      apiKey: environment.firebase.apiKey ?? '',
      authDomain: environment.firebase.authDomain ?? '',
      projectId: environment.firebase.projectId ?? '',
    })}`, { enabled: !isDevMode(), registrationStrategy: 'registerWhenStable:30000' }),

    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideRequiredMarker: true } },
    { provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS, useValue: { diameter: 40 } },

    // App initializers
    provideTranslationAppInitializer(),

    // Core providers
    provideConfigApiBaseUrl(environment.configBaseUrl),
    provideWebAppApiBaseUrl(environment.apiBaseUrl),
    provideFirebaseOptions(environment.firebase),
    provideFirebaseAuth(),
    provideGlobalErrorHandler(),
    provideLocaleId(),
    provideSnackbar(),
    provideStaticTranslation(),
  ],
};
